// extracted by mini-css-extract-plugin
module.exports = {"allLink":"_cc8e6f7","allButton":"_bf9df6e","icon":"_ab94840","right":"_25b2844"};